import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=bb151a9e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=bb151a9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb151a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb151a9e')) {
      api.createRecord('bb151a9e', component.options)
    } else {
      api.reload('bb151a9e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=bb151a9e&scoped=true&", function () {
      api.rerender('bb151a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27QB7kIt6xtbl/JS/comp/DocBox.vue"
export default component.exports